// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
Case Usage Example:
h1 { @include font-roboto(400); }
**/
h1 {
  font-size: 2rem;
  margin: 5px 0;
}
@media (max-width: 768px) {
  h1 {
    font-size: 1.5rem;
  }
}

h2 {
  font-size: 1.8rem;
  margin: 5px 0;
}
@media (max-width: 768px) {
  h2 {
    font-size: 1.2rem;
  }
}

:root {
  overflow-x: hidden;
  height: 100%;
}

* {
  font-family: "Roboto", sans-serif;
  font-weight: 200;
  box-sizing: border-box;
  outline: none;
}

*:focus {
  outline: none;
}

html,
body {
  margin: 0;
  padding: 0;
}

body {
  min-height: 100%;
  font-size: 1.3rem;
}
@media (max-width: 768px) {
  body {
    font-size: 1.2rem;
  }
}
@media (max-width: 576px) {
  body {
    font-size: 1.1rem;
  }
}

h1, h2, h3, h4, h5, h6 {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
}

.container {
  width: 100%;
  max-width: 1200px;
  padding: 15px;
  box-sizing: border-box;
  margin: 0 auto;
}

hr.style-one {
  width: 90%;
  border: 0;
  height: 1px;
  background: #333;
  background-image: linear-gradient(to right, #ccc, #333, #ccc);
}

hr.style-two {
  width: 90%;
  border: 0;
  height: 1px;
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0));
}

hr.style-three {
  width: 90%;
  border: 0;
  border-bottom: 1px dashed #ccc;
  background: #999;
}

.error-color {
  color: #aa004f;
}

/**  **/
.profile-wrapper,
.shifts-dashboard,
.profile-components,
.profile-page-content--show-tab { /* Safari, Chrome and Opera > 12.1 */ /* Firefox < 16 */ /* Internet Explorer */ /* Opera < 12.1 */
  animation: fadein 1s;
  min-height: calc(100vh - 230px);
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Firefox < 16 */
/* Safari, Chrome and Opera > 12.1 */
/* Internet Explorer */
/* Opera < 12.1 */
.browse-file-input {
  background-color: #F8F7F7;
  border: 1px solid #d6d6d6;
  border-radius: 25px;
  padding: 5px;
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  color: #B5B5B5;
  font-size: 0.8rem;
  gap: 10px;
  width: 100%;
  max-width: 350px;
  justify-content: space-between;
}
.browse-file-input input {
  display: none;
}
.browse-file-input .placeholder {
  overflow: hidden;
  width: 100%;
}
.browse-file-input .button-decor {
  background-color: #d6d6d6;
  border-radius: 25px;
  color: white;
  display: inline-flex;
  padding: 5px 10px;
  font-weight: bold;
  font-size: 0.7rem;
}`, "",{"version":3,"sources":["webpack://./src/css/fonts.scss","webpack://./src/widgets/BrowseFile/styles.scss","webpack://./src/css/general.scss","webpack://./src/css/colors.scss"],"names":[],"mappings":"AAMA;;;EAAA;AASA;EACE,eAAA;EACA,aAAA;ACTF;ADUE;EAHF;IAII,iBAAA;ECPF;AACF;;ADSA;EACE,iBAAA;EACA,aAAA;ACNF;ADOE;EAHF;IAII,iBAAA;ECJF;AACF;;ACpBA;EACE,kBAAA;EACA,YAAA;ADuBF;;ACrBA;EFJE,iCAAA;EACA,gBEIqB;EACrB,sBAAA;EACA,aAAA;ADyBF;;ACvBA;EACE,aAAA;AD0BF;;ACxBA;;EAEE,SAAA;EACA,UAAA;AD2BF;;ACzBA;EACE,gBAAA;EACA,iBFTO;ACqCT;AC1BE;EAJF;IAKI,iBFbK;EC0CP;AACF;AC5BE;EAPF;IAQI,iBFjBK;ECgDP;AACF;;AC5BA;EF7BE,iCAAA;EACA,gBE6BqB;ADgCvB;;AC7BA;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;ADgCF;;AC7BA;EACE,UAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,6DAAA;ADgCF;;AC9BA;EACE,UAAA;EACA,SAAA;EACA,WAAA;EACA,oGAAA;ADiCF;;AC/BA;EACE,UAAA;EACA,SAAA;EACA,8BAAA;EACA,gBAAA;ADkCF;;AChCA;EACE,cC3DO;AF8FT;;AC9BA,OAAA;AACA;;;kCAIE,oCAAA,EACA,iBAAA,EACA,sBAAA,EACA,iBAAA;EACA,oBAAA;EACA,+BAAA;ADiCF;;AC9BA;EACE;IAAO,UAAA;EDkCP;ECjCA;IAAO,UAAA;EDoCP;AACF;AClCA,iBAAA;AAMA,oCAAA;AAMA,sBAAA;AAMA,iBAAA;ADrGA;EACE,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,8BAAA;AA2JF;AAzJE;EACE,aAAA;AA2JJ;AAzJE;EACE,gBAAA;EACA,WAAA;AA2JJ;AAzJE;EACE,yBEpBK;EFqBL,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;AA2JJ","sourcesContent":["@import \"./breakpoints\";\n@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700;900&display=swap');\n@mixin font-roboto($weight) {\n  font-family: 'Roboto', sans-serif;\n  font-weight: $weight;\n}\n/**\nCase Usage Example:\nh1 { @include font-roboto(400); }\n**/\n\n$font-sm:1.1rem;\n$font-md:1.2rem;\n$font-lg:1.3rem;\n\nh1 {\n  font-size: 2rem;\n  margin: 5px 0;\n  @media (max-width: $md) {\n    font-size: 1.5rem;\n  }\n}\nh2 {\n  font-size: 1.8rem;\n  margin: 5px 0;\n  @media (max-width: $md) {\n    font-size: 1.2rem;\n  }\n}\n","@import \"../../css/colors\";\n@import \"../../css/breakpoints\";\n@import \"../../css/general\";\n\n.browse-file-input {\n  background-color: #F8F7F7;\n  border: 1px solid $color8;\n  border-radius: 25px;\n  padding: 5px;\n  display: inline-flex;\n  cursor: pointer;\n  align-items: center;\n  color: #B5B5B5;\n  font-size: 0.8rem;\n  gap: 10px;\n  width: 100%;\n  max-width: 350px;\n  justify-content: space-between;\n\n  input {\n    display: none;\n  }\n  .placeholder {\n    overflow: hidden;\n    width: 100%;\n  }\n  .button-decor {\n    background-color: $color8;\n    border-radius: 25px;\n    color: white;\n    display: inline-flex;\n    padding: 5px 10px;\n    font-weight: bold;\n    font-size: 0.7rem;\n  }\n}\n","@import \"fonts\";\n@import \"breakpoints\";\n@import \"colors\";\n:root {\n  overflow-x: hidden;\n  height: 100%;\n}\n* {\n  @include font-roboto(200);\n  box-sizing: border-box;\n  outline: none;\n}\n*:focus {\n  outline: none;\n}\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n}\nbody {\n  min-height: 100%;\n  font-size: $font-lg;\n  \n  @media (max-width: $md){\n    font-size: $font-md;\n  }\n  @media(max-width:$sm){\n    font-size: $font-sm;\n  }\n}\n\nh1, h2, h3 ,h4, h5, h6 {\n  @include font-roboto(400);\n}\n\n.container {\n  width: 100%;\n  max-width: 1200px;\n  padding: 15px;\n  box-sizing: border-box;\n  margin: 0 auto;\n}\n\nhr.style-one {\n  width: 90%;\n  border: 0;\n  height: 1px;\n  background: #333;\n  background-image: linear-gradient(to right, #ccc, #333, #ccc);\n}\nhr.style-two {\n  width: 90%;\n  border: 0;\n  height: 1px;\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0));\n}\nhr.style-three {\n  width: 90%;\n  border: 0;\n  border-bottom: 1px dashed #ccc;\n  background: #999;\n}\n.error-color {\n  color: $color6;\n}\n\n\n\n/**  **/\n.profile-wrapper,\n.shifts-dashboard,\n.profile-components,\n.profile-page-content--show-tab {\n  -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */\n  -moz-animation: fadein 1s; /* Firefox < 16 */\n  -ms-animation: fadein 1s; /* Internet Explorer */\n  -o-animation: fadein 1s; /* Opera < 12.1 */\n  animation: fadein 1s;\n  min-height: calc(100vh - 230px);\n}\n\n@keyframes fadein {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* Firefox < 16 */\n@-moz-keyframes fadein {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* Safari, Chrome and Opera > 12.1 */\n@-webkit-keyframes fadein {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* Internet Explorer */\n@-ms-keyframes fadein {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* Opera < 12.1 */\n@-o-keyframes fadein {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}","$color1: #e34634;\n$color2: #d02050;\n$color3: #46b1ff;\n$color4: #f5eee7;\n$color5: #baad9e;\n$color6: #aa004f;\n$color7: #bebebe;\n$color8: #d6d6d6;\n$color9: #f8f7f7;\n$color10: #202121;\n$color11: #848484;\n$color12: #aa004f;\n$color13: #37AA1E;\n$color14: #E4E5F1;\n$color15: #CB186B;\n$color16: #FCD3CA;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
